export let appPowerPoint = "uu7kae";
export default {appPowerPoint};